import React, { useContext } from "react";
import PropTypes from "prop-types";
import NavbarDropdown from "./NavbarDropdown";
import {
  solutionsRouts,
    insightsRouts,
    developersRouts,
    companyRouts
} from "../../landingRoutes";
import { NavItem } from "reactstrap";
import { breakpoints } from "../../helpers/utils";
import { navbarBreakPoint, topNavbarBreakpoint } from "../../config";
import AppContext from "../../context/Context";

const LandingNavbarTopDropDownMenus = ({ setNavbarCollapsed, setShowBurgerMenu }) => {
  const { isCombo, isTopNav } = useContext(AppContext);

  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
    isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };
  return (
    <>
      <NavbarDropdown
        title={solutionsRouts.name}
        items={solutionsRouts.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      <NavbarDropdown
        title={insightsRouts.name}
        items={insightsRouts.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      <NavbarDropdown
        title={developersRouts.name}
        items={developersRouts.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      <NavbarDropdown
        title={companyRouts.name}
        items={companyRouts.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />

<NavItem onClick={handleSetNavbarCollapsed}>
          <a className="nav-link" href="https://en.sikkasoft.com/request-a-demo/#contact-us" target="_blank" rel="noopener noreferrer">
          CONTACT US
          </a>
        </NavItem>
    </>
  );
};

LandingNavbarTopDropDownMenus.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default LandingNavbarTopDropDownMenus;
